import React, {Component} from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import {fetchSubscriptions, fetchMySubscriptions } from '../../../actions/subscriptions'
//import _ from 'lodash'
import SubscriptionTopic from './SubscriptionTopic'
import Typography from '@material-ui/core/Typography'
//import SvgIcon from 'material-ui/SvgIcon';

// material-ui imports
import List from '@material-ui/core/List';
import ListSubheader from '@material-ui/core/ListSubheader';
import { withStyles } from '@material-ui/core';
import Paper from '@material-ui/core/Paper'

const styles = theme => ({
    paper: {
        padding: theme.spacing.unit*2,
        marginBottom: theme.spacing.unit,
        //padding: '1em',
        //marginBottom: '1em',
        textAlign: 'center',
        color: theme.palette.text.secondary,
        backgroundColor: theme.palette.background.paper,
      },
      list: {
          padding: 0,
      },
    headline: {
        textAlign: 'left',
        boxShadow: '2px 2px 2px',
       // textTransform: 'uppercase'
       paddingBottom: '4px',
       marginBottom: theme.spacing.unit*2

    },
    subheader: {
        padding: 0,
    }
  });

class Subscription extends Component  {
   
   
   async componentDidMount ()  {
        const { functions } = this.props
        await functions.fetchMySubscriptions(this.props.userId)
        await functions.fetchSubscriptions()
      
        //await functions.doSetMyTopic(this.props, 'canidates')      
    }
   
    render() {
        const {subscriptions, mySubscriptions, classes } = this.props
        return (
                <Paper className={classes.paper}>
                    <List className ={classes.list} subheader={<ListSubheader className={classes.subheader}><Typography className={classes.headline} variant='title' color='primary'>Benachrichtigung</Typography></ListSubheader>}>
                        {subscriptions.map((topic, key)=>{
                    
                            return (
                                <SubscriptionTopic key={key} topic={topic} mySubscriptions={mySubscriptions}/>
                            )
                        })}
                    </List>
                </Paper>
        )
      }
}

const mapStateToProps = (state) => ({
    userId: state.sessionState.authUser.uid,
    subscriptions: state.subscriptionState.subscriptions,
    mySubscriptions: state.subscriptionState.mySubscriptions,
    notification: state.notificationState
})

const mapDispatchToProps = (dispatch) => ({
    functions: {
        fetchSubscriptions: ()=>fetchSubscriptions(dispatch),
        fetchMySubscriptions: (userId)=>fetchMySubscriptions(dispatch, userId),
        //doSetMyTopic: (mySubscriptions, topic)=>setMyTopic(dispatch, mySubscriptions, topic)
    },
    // onOpenEventDetails: (value) => dispatch({type: 'FETCH_SUBSCRIPTIONS', value})
  });

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles)
)(Subscription)


// WEBPACK FOOTER //
// ./src/Components/UserAuth/UserAccount/Subscription.js